import { isInternalAiNote, type CVEditingSection } from '@cibli/shared';

import { useCVTranslation } from '@/features/cv/hooks/useCVTranslation.ts';

import EditableSection from '../../../components/form/EditableSection';

interface ComplementaryInfoSectionProps {
  hasRQTH: boolean;
  mentions: string[] | undefined | null;
  onEdit?: (section: CVEditingSection) => void;
}

export default function ComplementaryInfoSection({
  hasRQTH,
  mentions,
  onEdit,
}: ComplementaryInfoSectionProps) {
  const { t } = useCVTranslation();
  const editable = onEdit !== undefined;
  const hasMentions = mentions && mentions.length > 0;

  if (!hasRQTH && !hasMentions && !editable) return null;

  const handleEdit = () => {
    if (onEdit) onEdit('complementaryInfo');
  };

  return (
    <EditableSection onEdit={handleEdit} editable={editable}>
      <div>
        <h2 className="text-[11px] font-black uppercase tracking-widest text-current pb-1.5 mb-1.5">
          {t('CV.complementaryInfo')}
        </h2>
        {hasRQTH && (
          <div className="text-[12px] text-current mb-1.5 font-semibold leading-relaxed">
            {t('CV.hasRQTH')}
          </div>
        )}
        {hasMentions &&
          mentions
            .filter(mention => mention.toUpperCase() !== 'RQTH' && !isInternalAiNote(mention))
            .map((mention, index) => (
              <div key={index} className="text-[11px] text-current mb-1.5 leading-relaxed">
                {mention}
              </div>
            ))}
      </div>
    </EditableSection>
  );
}
